import { Offer } from 'src/common/types/models/Offer'
import TokenIcon from 'src/common/ui-kit/TokenIcon/TokenIcon'
import { ZERO } from 'src/common/utils/big-utils'
import { displayAmount } from 'src/common/utils/formatters/number'
import { useTranslation } from 'react-i18next'
import './styles.css'
import { OfferStatus } from 'src/common/apollo/types/swarmx/graphql'

interface OfferTokensProps {
  offerStatus: Offer['offerStatus']
  availableAmount: Offer['availableAmount']
  amountIn: Offer['amountIn']
  amountOut: Offer['amountOut']
  depositAsset: Offer['depositAsset']
  withdrawalAsset: Offer['withdrawalAsset']
  swap?: boolean
}

const OfferTokens: React.FC<OfferTokensProps> = ({
  offerStatus,
  depositAsset,
  withdrawalAsset,
  availableAmount,
  amountIn,
  amountOut,
  swap = false,
}) => {
  const { t } = useTranslation('offersManagement', {
    keyPrefix: 'offerDetails',
  })

  const initialAmountIn = amountIn
  const initialAmountOut = amountOut || ZERO

  const availableAmountOut =
    amountOut?.div(amountIn)?.mul(availableAmount) || ZERO

  const sellAsset = swap ? depositAsset : withdrawalAsset
  const buyAsset = swap ? withdrawalAsset : depositAsset
  const sellAmount =
    offerStatus === OfferStatus.FullyTaken
      ? swap
        ? displayAmount(initialAmountIn)
        : displayAmount(initialAmountOut)
      : swap
      ? displayAmount(availableAmount)
      : displayAmount(availableAmountOut)
  const buyAmount =
    offerStatus === OfferStatus.FullyTaken
      ? swap
        ? displayAmount(initialAmountOut)
        : displayAmount(initialAmountIn)
      : swap
      ? displayAmount(availableAmountOut)
      : displayAmount(availableAmount)

  const sellTokenId =
    sellAsset.type !== 'ERC20' ? `#${sellAsset.tokenId}` : false
  const buyTokenId = buyAsset.type !== 'ERC20' ? `#${buyAsset.tokenId}` : false

  return (
    <div className='comp-offer-tokens'>
      <div className='comp-offer-tokens-item'>
        <TokenIcon width='20px' height='20px' token={sellAsset} />
        <span className='comp-offer-action-sell'>{t('sell')}</span>
        <span className='comp-offer-amount'>{sellAmount}</span>
        <span className='comp-offer-symbol'>
          {sellAsset.symbol} {sellTokenId}
        </span>
      </div>
      <div className='comp-offer-tokens-item'>
        <TokenIcon width='20px' height='20px' token={buyAsset} />
        <span className='comp-offer-action-buy'>{t('buy')}</span>
        <span className='comp-offer-amount'>{buyAmount}</span>
        <span className='comp-offer-symbol'>
          {buyAsset.symbol} {buyTokenId}
        </span>
      </div>
    </div>
  )
}

export default OfferTokens
